import { GoalsAndInterventionsNotesProps } from '@web-app/components/GoalsList/types';
import { AppointmentResponse } from '@web-app/hooks/queries/appointment-by-room-name/types';
import { Note } from '@web-app/server/api/types';
import { sanitizeHealthieDate } from '@web-app/utils/date-time.utils';

/**
 * Creates a formatted session note object for saving to the database
 */
export const getSessionNoteData = ({
  sessionNote,
  data,
  appointment,
  roomId,
}: {
  data?: Partial<GoalsAndInterventionsNotesProps> & {
    providerNotes?: string;
    providerNotesJson?: object | null;
  };
  sessionNote?: Partial<Note>;
  appointment?: AppointmentResponse | any;
  roomId?: string;
}) => ({
  sessionNote: {
    ...sessionNote?.sessionNote,
    appointmentDate: sanitizeHealthieDate(appointment?.healthie?.date),
    dailyRoomName: roomId,
    ...(typeof data?.providerNotes !== 'undefined' && {
      providerNotes: data?.providerNotes,
    }),
    ...(typeof data?.providerNotesJson !== 'undefined' && {
      providerNotesJson: data?.providerNotesJson,
    }),
    ...(appointment?.healthie_id &&
      appointment?.client_id &&
      appointment?.provider_id && {
        healthieAppointmentId: +appointment.healthie_id,
        healthieClientId: +appointment.client_id,
        healthieProviderId: +appointment.provider_id,
      }),
  },
  ...(sessionNote?.sessionNote && {
    clientGoals: {
      ...sessionNote?.clientGoals,
      ...(appointment?.client_id &&
        appointment?.provider_id && {
          healthieClientId: +appointment.client_id,
          healthieProviderId: +appointment.provider_id,
        }),
      ...(typeof data?.currentGlobalInterventions !== 'undefined' && {
        clientGoalsAndIntentions:
          data?.currentGlobalInterventions?.clientGoalsAndIntentions,
        actionableIntervention:
          data?.currentGlobalInterventions?.actionableIntervention,
        comments: data?.currentGlobalInterventions?.comments,
      }),
      ...(typeof data?.selectedClientGoalsAndInterventions !== 'undefined' && {
        selectedClientGoalsAndInterventions: JSON.stringify(
          data?.selectedClientGoalsAndInterventions,
        ),
      }),
      ...(typeof data?.isGoalsAndInterventionsEditorOpen !== 'undefined' && {
        isGoalsAndInterventionsEditorOpen:
          data?.isGoalsAndInterventionsEditorOpen,
      }),
      ...(typeof data?.currentlySelectedGoalIndex !== 'undefined' && {
        currentlySelectedGoalIndex: data?.currentlySelectedGoalIndex,
      }),
    },
  }),
});
